import { setCustomNativeDragPreview } from "@atlaskit/pragmatic-drag-and-drop/element/set-custom-native-drag-preview";
import { centerUnderPointer } from "@atlaskit/pragmatic-drag-and-drop/element/center-under-pointer";

export interface DragPreviewOptions {
  opacity?: string;
  shadow?: string;
  borderRadius?: string;
  width?: string;
  customStyles?: Partial<CSSStyleDeclaration>;
}

interface GenerateDragPreviewArgs {
  nativeSetDragImage: DataTransfer['setDragImage'] | null;
  location: {
    current: {
      input: {
        clientX: number;
        clientY: number;
      };
    };
  };
  source: {
    element: Element;
    data: Record<string, unknown>;
  };
}

export const createDragPreview = (
  element: HTMLElement,
  options: DragPreviewOptions = {}
): ((args: GenerateDragPreviewArgs) => void) => {
  const {
    opacity = "0.9",
    shadow = "0 12px 28px rgba(0, 0, 0, 0.25)",
    borderRadius = "0",
    width,
    customStyles = {},
  } = options;

  return ({ nativeSetDragImage }: GenerateDragPreviewArgs) => {
    if (!nativeSetDragImage) {
      return;
    }

    setCustomNativeDragPreview({
      nativeSetDragImage,
      getOffset: centerUnderPointer,
      render: ({ container }) => {
        // Clone the element for the preview
        const preview = element.cloneNode(true) as HTMLElement;

        // Apply base styles
        preview.style.width = width || `${element.offsetWidth}px`;
        preview.style.opacity = opacity;
        preview.style.boxShadow = shadow;
        preview.style.borderRadius = borderRadius;
        preview.style.pointerEvents = "none";

        // Apply custom styles if provided
        Object.entries(customStyles).forEach(([key, value]) => {
          if (value !== undefined) {
            (preview.style as any)[key] = value;
          }
        });

        container.appendChild(preview);
      },
    });
  };
};
